import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NUMBER_1 } from '~shared/constants';
import { BestOffer } from '~shared/models';

@Component({
  selector: 'app-plps-add-to-cart-quantity-check-tooltip',
  templateUrl: './quantity-check-tooltip.component.html',
  styleUrls: ['./quantity-check-tooltip.component.scss'],
})
export class PlpAddToCartQuantityCheckTooltipComponent {
  NUMBER_1 = NUMBER_1;
  @Input() currentOffer: BestOffer;
  @Input() noOfOffers: number;
  @Output() hideTooltip = new EventEmitter();

  constructor() {}

  closeDialog(): void {
    this.hideTooltip.emit();
  }
}
